<template>
  <div class="layout">
    <el-container direction="vertical">
      <global-header />
      <el-container class="main-wrapper">
        <el-main>
          <el-row type="flex" class="main-row">
            <el-col :span="24">
              <transition name="el-fade-in" mode="out-in">
                <route-view />
              </transition>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <global-footer />
    </el-container>
    <back-top />
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader';
import GlobalFooter from '@/components/GlobalFooter';
import RouteView from '@/layouts//RouteView.vue';
import BackTop from '@/components/BackTop';

export default {
  name: 'TodoListLayout',
  components: {
    GlobalHeader,
    RouteView,
    GlobalFooter,
    BackTop,
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
.layout
  display flex
  flex auto
  width 100%
  height auto
  min-height 100vh
  overflow-x hidden
  flex-direction row
  .main-wrapper
    width 1200px
    margin 0 auto
    padding 20px 0
    .el-main
      flex-column()
      padding 0 0 0 20px
      .main-row
        flex 1
</style>
